// API Configuration
// In production, this will be automatically set to the current domain
const getApiUrl = () => {
  // Determine if running in a production environment
  const isProduction = window.location.hostname === 'www.easycodingtools.com' || 
                       window.location.hostname === 'easycodingtools.com' ||
                       window.location.hostname.endsWith('.onrender.com'); // For Render hosted frontend

  if (isProduction) {
    // Use the dedicated production API URL
    return 'https://easycodingtools-api.onrender.com/api';
  }
  // Development - use localhost or a local environment variable
  return process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
};

export const API_URL = getApiUrl();


